import { FC } from 'react';

type BrokerSaleIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BrokerSaleIcon: FC<BrokerSaleIconProps> = ({
  width = 48,
  height = 48,
  color = '#D25D3E',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4Z" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 12V14M24 34V36" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 19C18 16.238 20.686 14 24 14C27.314 14 30 16.238 30 19C30 21.762 27.314 24 24 24C20.686 24 18 26.238 18 29C18 31.762 20.686 34 24 34C27.314 34 30 31.762 30 29" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
